module.exports = __webpack_public_path__ + "img/ph.9f40a72f.svg";